import type { ClientFeature } from '@DigitaleDoerfer/digitale-doerfer-api';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { FEATURE_SETTING_STORE_KEY } from '@/features/feature-management/constants/store';

export type FeatureSettingStore = {
  features: ClientFeature[];
  setFeatures: (features: ClientFeature[]) => void;
  setFeature: (feature: string, value: boolean) => void;
};

export const useFeatureSettingStore = create<FeatureSettingStore>()(
  persist(
    (set, get) => ({
      features: [],
      setFeatures: (newFeatures: ClientFeature[]) => {
        set({ features: [...newFeatures] });
      },
      setFeature: (feature: string, enabled: boolean) => {
        set({
          features: [
            ...get().features.filter((f) => f.featureIdentifier !== feature),
            { id: feature, featureIdentifier: feature, enabled }
          ]
        });
      }
    }),
    {
      name: FEATURE_SETTING_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
